<ul>
  <li><a routerLink="/" routerLinkActive="nav_active">home</a></li>
  <li><a routerLink="/contact" routerLinkActive="nav_active">contact us</a></li>
</ul>
